import { useNavigate } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";
import { ProtectedRoutes } from "../../utils/routes.utils";
import { Button, ButtonProps } from "../ui/Button/Button";
import "./SurveyLaunchButton.scss";

interface SurveyLaunchButtonProps extends ButtonProps {
  canLaunchNewDispatch?: boolean;
}

export const SurveyLaunchButton = ({
  children,
  className,
  color,
  small = true,
  canLaunchNewDispatch = true,
}: SurveyLaunchButtonProps) => {
  const { t } = useTranslation("workplaceCulturePage");
  const navigate = useNavigate();

  if (!canLaunchNewDispatch) {
    return null;
  }

  return (
    <Button
      variant="contained"
      color={color}
      small={small}
      onClick={() => navigate(ProtectedRoutes.LAUNCH)}
      className={className}
    >
      {children || t("dispatches.create")}
    </Button>
  );
};
